import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=c7385d2a&scoped=true&"
import script from "./addCustom.vue?vue&type=script&lang=js&"
export * from "./addCustom.vue?vue&type=script&lang=js&"
import style0 from "./addCustom.vue?vue&type=style&index=0&id=c7385d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7385d2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7385d2a')) {
      api.createRecord('c7385d2a', component.options)
    } else {
      api.reload('c7385d2a', component.options)
    }
    module.hot.accept("./addCustom.vue?vue&type=template&id=c7385d2a&scoped=true&", function () {
      api.rerender('c7385d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/custom/addCustom.vue"
export default component.exports